<template>
    <div class="card-section-container" :class="class">
        <div 
            v-if="title || $slots.title"
            class="card-title-container"
            :style="needsBorder ? 'border-bottom: 1px solid rgba(0,0,0,0.1);' : ''"
        >
            <div class="card-title-left">
                <template v-if="$slots.title">
                    <slot name="title"></slot> <!-- 슬롯으로 타이틀 삽입 -->
                </template>
                <template v-else>
                    <h5>{{ title }}</h5> <!-- title이 있을 때 기본적으로 텍스트 표시 -->
                </template>
            </div>
            <div class="card-btn-area"  v-if="$slots.button">
                <template v-if="$slots.button">
                    <slot name="button"></slot>
                </template>
            </div>
        </div>
        <div class="card-content-container">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
        },
        class: {
            type: String,
        },
        needsBorder: {
            type: Boolean,
        }
    },
}
</script>
<style lang="scss" scoped>

$Gray-10: #F1F2F3;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;

.card-section-container {
  width: 100%;
  display: flex;
  background-color: white;
  border-radius: 14px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
  padding: 0;
  .card-title-container {
      width: 100%;
      min-height: 52px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      gap: 10px;
      h5 {
        font-size: 17px;
        color: $Gray-90;
        font-family: 'SuitBold';
        margin-bottom: 0;
      }
  }
  .card-content-container {
      width: 100%;
      height: 100%;
  }
}



</style>

